import { InterpreterOptions, MachineOptions } from 'xstate'
import { UseMachineOptions } from '@xstate/react/lib/useMachine'
import { BatchCampaignPreparation, BrandPlan, Source } from 'types'
import { BrandPlanScheduleCrosspostInput, VariablesOf } from 'hooks/queries/brandKits/useCreateSchedule'
import { ImageMenuSelectedImage } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'

export interface BatchCampaignsProps {
  numberOfCampaigns: number
  onExit: () => void
  brandPlan: BrandPlan
}

export interface TopicsFieldProps {
  numberOfCampaigns: number
}

export enum EventId {
  Back = 'Back',
  Continue = 'Continue',
  Error = 'Error',
  Finish = 'Finish',
  PreparationComplete = 'PreparationComplete',
  PrepareBatch = 'PrepareBatch',
}

export enum StateId {
  CreateBatch = 'CreateBatch',
  Analysing = 'Analysing',
  Review = 'Review',
}

export interface Context {
  topics: string[]
  start_date: string
  number_of_campaigns: number
  sources: Array<Source & { save_media?: boolean }>
  media: ImageMenuSelectedImage[]
  campaigns: VariablesOf<BrandPlanScheduleCrosspostInput>[]
  transient: {
    error?: Error
    abortController: AbortController
  }
}

export interface BackEvent {
  type: EventId.Back
}

export interface ContinueEvent {
  type: EventId.Continue
}

export interface ErrorEvent {
  type: EventId.Error
  error: Error
}

export interface PrepareBatchEvent {
  type: EventId.PrepareBatch
  topics: string[]
  start_date: string
  sources: Array<Source & { save_media?: boolean }>
  media: ImageMenuSelectedImage[]
}

export interface PreparationCompleteEvent {
  type: EventId.PreparationComplete
  preparation: BatchCampaignPreparation
}

export interface FinishEvent {
  type: EventId.Finish
  campaigns: VariablesOf<BrandPlanScheduleCrosspostInput>[]
}

export type Event = BackEvent | ErrorEvent | ContinueEvent | PrepareBatchEvent | PreparationCompleteEvent | FinishEvent

export type State =
  | {
      value: StateId.CreateBatch
      context: Context
    }
  | {
      value: StateId.Analysing
      context: Context
    }
  | {
      value: StateId.Review
      context: Context
    }

export interface Props {
  brandPlanId: number
}

export type Options = Partial<InterpreterOptions> &
  Partial<UseMachineOptions<Context, Event>> &
  Partial<MachineOptions<Context, Event>>
